module.exports = __webpack_public_path__ + "img/astro.5397a34a.png";